'use strict';

var getKeys = require('../utils/getKeys');

module.exports = function (object, method, fn) {
  return getKeys(object)[method](function (key) {
    return fn(object[key], key, object);
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/utils/objectIterator.js
// module id = 732
// module chunks = 37